// extracted by mini-css-extract-plugin
module.exports = {"center":"Center_center__pKOls"};